exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.field-container--social_campaign_detail .field-label[data-v-669de174] {\n\tmargin-bottom:14px;\n}\n", ""]);

// exports
